jQuery(function ($) {
  const appUrl = window["app_url"];

  // custom login process
  const frm = $('#customer_login');
  const frmErrorWrapper = frm.find('#form-register-error');
  const frmErrors = frmErrorWrapper.find('.errors');
  const loginBtn = frm.find('button');
  const btnLoginText = loginBtn.text();
  let currentRequest = null;

  // define from validator
  frm.validate({
    rules: {
      "customer[email]": {
        required: true,
        email: true
      },
      "customer[password]": "required",
    },
  });

  frm.on("submit", function (e) {
    e.preventDefault();
    frmErrorWrapper.hide();
    frmErrors.html("");

    // check form is valid
    if (!frm.valid()) {
      return;
    }

    const email = frm.find('input#CustomerEmail').val();
    const password = frm.find('input#CustomerPassword').val();
    const postData = {"email": email, "password": password};

    currentRequest = $.ajax({
      type: frm.attr('method'),
      url: appUrl + '/customer/login', // login to memberson first
      data: JSON.stringify(postData),
      contentType: "application/json; charset=utf-8",
      beforeSend: function () {
        if (currentRequest != null) {
          currentRequest.abort();
        }

        loginBtn.attr('disabled', true);
        loginBtn.text('Logging in ...');
      },
      success: function (res) {
        if (res.success) {
          // shopifyLogin(frm);
          location.href = `/account/login/multipass/${res.login_token}`;
        } else {
          const errorsHtml = '<ul>' +
            ' <li>' + res.message + '</li>' +
            '</ul>';

          frmErrors.html(errorsHtml);
          frmErrorWrapper.show();
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        const res = xhr.responseJSON;
        const errorsHtml = '<ul>' +
          ' <li>' + res.message + '</li>' +
          '</ul>';

        frmErrors.html(errorsHtml);
        frmErrorWrapper.show();
        loginBtn.removeAttr('disabled');
        loginBtn.text(btnLoginText);
        $('html, body').animate({
          scrollTop: 0
        }, 500);
      }
    });
  });

  // login to shopify
  function shopifyLogin(frm) {
    currentRequest = $.ajax({
      type: frm.attr('method'),
      url: frm.attr('action'),
      data: frm.serialize(),
      beforeSend: function () {
        if (currentRequest != null) {
          currentRequest.abort();
        }

        frm.find('button').text('Logging in ...');
      },
      success: function (data) {
        var resLoginForm = $(data).find('form#customer_login');
        if (resLoginForm.length > 0) {
          frm.find('.errors').remove();
          frm.find('.form__message').remove();
          frm.prepend('<div class="errors">' + resLoginForm.find('.errors').html() + '</div>');
          frm.prepend('<h2 class="form__message" tabindex="-1" autofocus="">' + resLoginForm.find('.form__message').html() + '</h2>');
        } else {
          location = '/account';
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        loginBtn.text(btnLoginText);
        loginBtn.removeAttr('disabled');
        $('html, body').animate({
          scrollTop: 0
        }, 500);
      }
    });
  }
});
